module.exports = __webpack_public_path__ + "img/危固废动态管理平台.0f769bb5.png";